import {
  Box,
  Center,
  Divider,
  IconButton,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { BiSolidXCircle } from "react-icons/bi";
import { FaCheckCircle } from "react-icons/fa";
import { FaRegFile } from "react-icons/fa6";
import { HiUpload } from "react-icons/hi";
import {
  IoIosArrowDown,
  IoIosArrowForward,
  IoIosArrowUp,
  IoMdInformationCircleOutline,
} from "react-icons/io";
import { LuIndianRupee, LuXSquare } from "react-icons/lu";
import { PiHandSwipeRightThin, PiUserCheck } from "react-icons/pi";
const LoanOfficerMain = () => {
  const [toggleAccordian, setToggleAccordian] = useState(false);
  const [expandedRow, setExpandedRow] = useState(null);

  // Toggle Accordion Function
  const toggleAccordion = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };

  return (
    <div className="">
      <Box
        height={"70px"}
        backgroundColor={"white"}
        borderRadius={"20px"}
        boxShadow={
          "rgba(17, 17, 26, 0.05) 0px 0px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px;"
        }
        marginBottom={"30px"}
        paddingX={"25px"}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <div className="text-[16px]" style={{ fontWeight: "600" }}>
          Loan Officer View
        </div>
        <button className="h-[40px] w-[112px] bg-[#F1A254] rounded-[8px] flex items-center justify-center gap-x-2 text-white font-[700]">
          <Text fontSize={"14px"} fontWeight={"700"}>
            Show log
          </Text>
          <IoIosArrowForward className="h-4 w-4" />
        </button>
      </Box>
      <Box
        height={"70px"}
        backgroundColor={"white"}
        borderRadius={"20px"}
        boxShadow={
          "rgba(17, 17, 26, 0.05) 0px 0px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px;"
        }
        marginBottom={"30px"}
        display={"flex"}
        justifyContent={"space-between"}
        paddingX={"25px"}
        alignItems={"center"}
      >
        <div className="text-[16px]">Current Status of the company.</div>
        <button
          className="h-[40px] w-[150px] bg-[#F8F8F8] rounded-[6px] flex items-center justify-center gap-x-2 text-[#595657]"
          style={{ border: "1px solid #E8E8E8" }}
        >
          <Text fontSize={"14px"} fontWeight={"700"}>
            Data Collection
          </Text>
          <IoIosArrowDown className="h-4 w-4" />
        </button>
      </Box>
      <Box
        backgroundColor={"white"}
        borderRadius={"20px"}
        boxShadow={
          "rgba(17, 17, 26, 0.05) 0px 0px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px;"
        }
        marginBottom={"30px"}
        padding={"20px"}
      >
        <Box minHeight={"192px"} marginBottom={"30px"}>
          <Text fontWeight={"700"} fontSize={"18px"}>
            Loan Details
          </Text>
          <Box
            height={"160px"}
            border={"1px solid #E8E8E8"}
            borderRadius={"8px"}
            marginTop={"15px"}
          >
            <Box display={"flex"} padding={"16px"} columnGap={"180px"}>
              <Box width={"89px"} height={"47px"}>
                <Text
                  fontSize={"14px"}
                  color={"#595657"}
                  className="whitespace-nowrap"
                >
                  Loan Amount
                </Text>
                <Text
                  display={"flex"}
                  justifyContent={"flex-start"}
                  alignItems={"center"}
                  fontSize={"16px"}
                  color={"#3A9391"}
                  fontWeight={"600"}
                  marginTop={"5px"}
                >
                  <LuIndianRupee /> 45,000
                </Text>
              </Box>
              <Box min-width={"89px"} height={"47px"} className="-ml-3">
                <Text
                  fontSize={"14px"}
                  color={"#595657"}
                  className="whitespace-nowrap"
                >
                  Loan Purpose
                </Text>
                <Text
                  display={"flex"}
                  justifyContent={"flex-start"}
                  alignItems={"center"}
                  fontSize={"16px"}
                  color={"#3A9391"}
                  fontWeight={"600"}
                  marginTop={"5px"}
                >
                  Business
                </Text>
              </Box>
              <Box min-width={"89px"} height={"47px"}>
                <Text
                  fontSize={"14px"}
                  color={"#595657"}
                  className="whitespace-nowrap"
                >
                  Borrower Industry
                </Text>
                <Text
                  display={"flex"}
                  justifyContent={"flex-start"}
                  alignItems={"center"}
                  fontSize={"16px"}
                  color={"#3A9391"}
                  fontWeight={"600"}
                  marginTop={"5px"}
                  className="whitespace-nowrap"
                >
                  Jewellery and Gems
                </Text>
              </Box>
            </Box>
            <Box display={"flex"} padding={"16px"} columnGap={"180px"}>
              <Box min-width={"89px"} height={"47px"}>
                <Text fontSize={"14px"} color={"#595657"}>
                  State
                </Text>
                <Text
                  display={"flex"}
                  justifyContent={"flex-start"}
                  alignItems={"center"}
                  fontSize={"16px"}
                  color={"#3A9391"}
                  fontWeight={"600"}
                  marginTop={"5px"}
                >
                  Karnataka
                </Text>
              </Box>
              <Box min-width={"89px"} height={"47px"}>
                <Text fontSize={"14px"} color={"#595657"}>
                  Onboarding Start Date
                </Text>
                <Text
                  display={"flex"}
                  justifyContent={"flex-start"}
                  alignItems={"center"}
                  fontSize={"16px"}
                  color={"#3A9391"}
                  fontWeight={"600"}
                  marginTop={"5px"}
                >
                  05 Oct 2024
                </Text>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box minHeight={"192px"} margin={"40px 0px 20px 0px"}>
          <Text fontWeight={"700"} fontSize={"18px"}>
            Document Submitted
          </Text>
          <Text
            fontWeight={"700"}
            fontSize={"16px"}
            color={"#3A9391"}
            marginTop={"10px"}
          >
            Data Submitted by Customer
          </Text>
          <Box style={{ marginTop: "25px" }}>
            <Table
              variant="unstyled"
              size="md"
              width="100%"
              bg="white"
              borderRadius="md"
            >
              <Thead>
                <Tr>
                  <Th
                    fontSize={"12px"}
                    color={"#595657"}
                    fontWeight={"400"}
                    fontFamily={"inter"}
                    textTransform={"capitalize"}
                  >
                    File
                  </Th>
                  <Th
                    fontSize={"12px"}
                    color={"#595657"}
                    fontWeight={"400"}
                    fontFamily={"inter"}
                    textTransform={"capitalize"}
                  >
                    Preview
                  </Th>
                  <Th
                    fontSize={"12px"}
                    color={"#595657"}
                    fontWeight={"400"}
                    fontFamily={"inter"}
                    textTransform={"capitalize"}
                  >
                    Human Action
                  </Th>
                  <Th
                    fontSize={"12px"}
                    color={"#595657"}
                    fontWeight={"400"}
                    fontFamily={"inter"}
                    textTransform={"capitalize"}
                  >
                    <span className="mx-auto">Review Status</span>
                  </Th>
                </Tr>
              </Thead>
              <Tbody style={{ border: "1px solid #E8E8E8" }}>
                <Tr style={{ borderBottom: "1px solid #E8E8E8" }}>
                  <Td>
                    <Stack direction="row" align="center" spacing={2}>
                      <FaRegFile className="h-4  w-4 text-[#F1A254]" />
                      <Text
                        fontWeight="400"
                        color={"#090705"}
                        fontSize={"14px"}
                      >
                        Aadhaar Card
                      </Text>
                      <IoMdInformationCircleOutline className="h-5 w-5 text-[#B3B3B3]" />
                      <button
                        style={{
                          border: "1px solid #E8E8E8",
                          color: "#F1A254",
                          height: "30px",
                          width: "46px",
                          backgroundColor: "#F8F8F8",
                          fontSize: "12px",
                          borderRadius: "8px",
                          fontWeight: "600",
                          marginLeft: "2px",
                        }}
                      >
                        Log
                      </button>
                    </Stack>
                  </Td>
                  <Td>
                    <IconButton
                      icon={<PiHandSwipeRightThin />}
                      variant="unstyled"
                      aria-label="Preview"
                    />
                  </Td>
                  <Td>
                    <IconButton
                      icon={<PiUserCheck className="text-white" />}
                      variant="unstyled"
                      aria-label="Human Approval"
                    />
                  </Td>
                  <Td>
                    <Stack direction="row" align="center" spacing={3}>
                      <Box className="flex items-center gap-x-2">
                        <FaCheckCircle className="h-4 w-4 text-[#3A9391]" />
                        <Text
                          className="text-[#3A9391] text-[14px]"
                          fontWeight={"700"}
                        >
                          Approved
                        </Text>
                      </Box>
                      <Center height="40px">
                        <Divider orientation="vertical" />
                      </Center>
                      <button
                        className="flex items-center justify-center gap-x-2 h-[40px] w-[104px] rounded-[8px]"
                        style={{ border: "1px solid #E8E8E8" }}
                      >
                        <HiUpload className="h-4 w-4 text-[#F1A254]" />
                        <Text
                          className="text-[#595657] text-[14px]"
                          fontWeight={"700"}
                        >
                          Override
                        </Text>
                      </button>

                      <button>
                        <IoIosArrowDown className="h-4 w-4" />
                      </button>
                    </Stack>
                  </Td>
                </Tr>
                <Tr style={{ borderBottom: "1px solid #E8E8E8" }}>
                  <Td>
                    <Stack direction="row" align="center" spacing={2}>
                      <FaRegFile className="h-4  w-4 text-[#F1A254]" />
                      <Text
                        fontWeight="400"
                        color={"#090705"}
                        fontSize={"14px"}
                      >
                        Pan Card
                      </Text>
                      <IoMdInformationCircleOutline className="h-5 w-5 text-[#B3B3B3]" />
                      <button
                        style={{
                          border: "1px solid #E8E8E8",
                          color: "#F1A254",
                          height: "30px",
                          width: "46px",
                          backgroundColor: "#F8F8F8",
                          fontSize: "12px",
                          borderRadius: "8px",
                          fontWeight: "600",
                          marginLeft: "2px",
                        }}
                      >
                        Log
                      </button>
                    </Stack>
                  </Td>
                  <Td>
                    <IconButton
                      icon={<PiHandSwipeRightThin />}
                      variant="unstyled"
                      aria-label="Preview"
                    />
                  </Td>
                  <Td>
                    <IconButton
                      icon={<PiUserCheck />}
                      variant="unstyled"
                      aria-label="Human Approval"
                    />
                  </Td>
                  <Td>
                    <Stack direction="row" align="center" spacing={3}>
                      <Box className="flex items-center gap-x-2">
                        <BiSolidXCircle className="h-5 w-5 text-[#FF3B30]" />
                        <Text
                          className="text-[#FF3B30] text-[14px]"
                          fontWeight={"700"}
                        >
                          Rejected
                        </Text>
                      </Box>
                      <Center height="40px">
                        <Divider orientation="vertical" />
                      </Center>
                      <button
                        className="flex items-center justify-center gap-x-2 h-[40px] w-[104px] rounded-[8px]"
                        style={{ border: "1px solid #E8E8E8" }}
                      >
                        <HiUpload className="h-4 w-4 text-[#F1A254]" />
                        <Text
                          className="text-[#595657] text-[14px]"
                          fontWeight={"700"}
                        >
                          Override
                        </Text>
                      </button>
                      <button
                        onClick={() => setToggleAccordian((prev) => !prev)}
                      >
                        {toggleAccordian ? (
                          <IoIosArrowUp className="h-4 w-4" />
                        ) : (
                          <IoIosArrowDown className="h-4 w-4" />
                        )}
                      </button>
                    </Stack>
                  </Td>
                </Tr>
                {toggleAccordian && (
                  <Tr
                    min-height="100px"
                    borderTop="none"
                    style={{ borderBottom: "1px solid #E8E8E8" }}
                  >
                    <Td colSpan="100%">
                      <TableContainer>
                        <Table variant="simple">
                          <Thead>
                            <Tr>
                              <Th
                                fontSize={"12px"}
                                color={"#595657"}
                                fontWeight={"400"}
                                fontFamily={"inter"}
                                textTransform={"capitalize"}
                              >
                                Checklist
                              </Th>
                              <Th
                                fontSize={"12px"}
                                color={"#595657"}
                                fontWeight={"400"}
                                fontFamily={"inter"}
                                textTransform={"capitalize"}
                              >
                                Check Status
                              </Th>
                              <Th
                                fontSize={"12px"}
                                color={"#595657"}
                                fontWeight={"400"}
                                fontFamily={"inter"}
                                textTransform={"capitalize"}
                              >
                                Exception Reason
                              </Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            <Tr>
                              <Td
                                fontSize={"14px"}
                                color={"#090705"}
                                fontWeight={"400"}
                              >
                                PAN Visibility
                              </Td>
                              <Td className="">
                                <LuXSquare className="mx-auto h-5 w-5 text-[#FF3B30] " />
                              </Td>
                              <Td>
                                <button
                                  className="h-[30px] w-[180px] bg-white rounded-[6px] flex items-center justify-center gap-x-2 text-[#ccc]"
                                  style={{ border: "1px solid #E8E8E8" }}
                                >
                                  <Text fontSize={"12px"} fontWeight={"700"}>
                                    Please select a reason
                                  </Text>
                                  <IoIosArrowDown className="h-4 w-4" />
                                </button>
                              </Td>
                            </Tr>
                            <Tr>
                              <Td
                                fontSize={"14px"}
                                color={"#090705"}
                                fontWeight={"400"}
                              >
                                PAN Name Match
                              </Td>
                              <Td className="">
                                <LuXSquare className="mx-auto h-5 w-5 text-[#FF3B30] " />
                              </Td>
                              <Td>
                                <button
                                  className="h-[30px] w-[180px] bg-white rounded-[6px] flex items-center justify-center gap-x-2 text-[#ccc]"
                                  style={{ border: "1px solid #E8E8E8" }}
                                >
                                  <Text fontSize={"12px"} fontWeight={"700"}>
                                    Please select a reason
                                  </Text>
                                  <IoIosArrowDown className="h-4 w-4" />
                                </button>
                              </Td>
                            </Tr>
                            <Tr>
                              <Td
                                fontSize={"14px"}
                                color={"#090705"}
                                fontWeight={"400"}
                              >
                                Politically Exposed Person Check
                              </Td>
                              <Td className="">
                                <LuXSquare className="mx-auto h-5 w-5 text-[#FF3B30] " />
                              </Td>
                              <Td>
                                <button
                                  className="h-[30px] w-[180px] bg-white rounded-[6px] flex items-center justify-center gap-x-2 text-[#ccc]"
                                  style={{ border: "1px solid #E8E8E8" }}
                                >
                                  <Text fontSize={"12px"} fontWeight={"700"}>
                                    Please select a reason
                                  </Text>
                                  <IoIosArrowDown className="h-4 w-4" />
                                </button>
                              </Td>
                            </Tr>
                          </Tbody>
                        </Table>
                      </TableContainer>
                    </Td>
                  </Tr>
                )}
                <Tr style={{ borderBottom: "1px solid #E8E8E8" }}>
                  <Td>
                    <Stack direction="row" align="center" spacing={2}>
                      <FaRegFile className="h-4  w-4 text-[#F1A254]" />
                      <Text
                        fontWeight="400"
                        color={"#090705"}
                        fontSize={"14px"}
                        className="whitespace-nowrap"
                      >
                        Audited Financials
                      </Text>
                      <IoMdInformationCircleOutline className="h-5 w-5 text-[#B3B3B3]" />
                      <button
                        style={{
                          border: "1px solid #E8E8E8",
                          color: "#F1A254",
                          height: "30px",
                          width: "46px",
                          backgroundColor: "#F8F8F8",
                          fontSize: "12px",
                          borderRadius: "8px",
                          fontWeight: "600",
                          marginLeft: "2px",
                        }}
                      >
                        Log
                      </button>
                    </Stack>
                  </Td>
                  <Td>
                    <IconButton
                      icon={<PiHandSwipeRightThin />}
                      variant="unstyled"
                      aria-label="Preview"
                    />
                  </Td>
                  <Td>
                    <IconButton
                      icon={<PiUserCheck className="text-white" />}
                      variant="unstyled"
                      aria-label="Human Approval"
                    />
                  </Td>
                  <Td>
                    <Stack direction="row" align="center" spacing={3}>
                      <Box className="flex items-center gap-x-2">
                        <FaCheckCircle className="h-4 w-4 text-[#3A9391]" />
                        <Text
                          className="text-[#3A9391] text-[14px]"
                          fontWeight={"700"}
                        >
                          Approved
                        </Text>
                      </Box>
                      <Center height="40px">
                        <Divider orientation="vertical" />
                      </Center>
                      <button
                        className="flex items-center justify-center gap-x-2 h-[40px] w-[104px] rounded-[8px]"
                        style={{ border: "1px solid #E8E8E8" }}
                      >
                        <HiUpload className="h-4 w-4 text-[#F1A254]" />
                        <Text
                          className="text-[#595657] text-[14px]"
                          fontWeight={"700"}
                        >
                          Override
                        </Text>
                      </button>
                      <button>
                        <IoIosArrowDown className="h-4 w-4" />
                      </button>
                    </Stack>
                  </Td>
                </Tr>
                <Tr style={{ borderBottom: "1px solid #E8E8E8" }}>
                  <Td>
                    <Stack direction="row" align="center" spacing={2}>
                      <FaRegFile className="h-4  w-4 text-[#F1A254]" />
                      <Text
                        fontWeight="400"
                        color={"#090705"}
                        fontSize={"14px"}
                        className="whitespace-nowrap"
                      >
                        Bank Statements
                      </Text>
                      <IoMdInformationCircleOutline className="h-5 w-5 text-[#B3B3B3]" />
                      <button
                        style={{
                          border: "1px solid #E8E8E8",
                          color: "#F1A254",
                          height: "30px",
                          width: "46px",
                          backgroundColor: "#F8F8F8",
                          fontSize: "12px",
                          borderRadius: "8px",
                          fontWeight: "600",
                          marginLeft: "2px",
                        }}
                      >
                        Log
                      </button>
                    </Stack>
                  </Td>
                  <Td>
                    <IconButton
                      icon={<PiHandSwipeRightThin />}
                      variant="unstyled"
                      aria-label="Preview"
                    />
                  </Td>
                  <Td>
                    <IconButton
                      icon={<PiUserCheck className="text-white" />}
                      variant="unstyled"
                      aria-label="Human Approval"
                    />
                  </Td>
                  <Td>
                    <Stack direction="row" align="center" spacing={3}>
                      <Box className="flex items-center gap-x-2">
                        <FaCheckCircle className="h-4 w-4 text-[#3A9391]" />
                        <Text
                          className="text-[#3A9391] text-[14px]"
                          fontWeight={"700"}
                        >
                          Approved
                        </Text>
                      </Box>
                      <Center height="40px">
                        <Divider orientation="vertical" />
                      </Center>
                      <button
                        className="flex items-center justify-center gap-x-2 h-[40px] w-[104px] rounded-[8px]"
                        style={{ border: "1px solid #E8E8E8" }}
                      >
                        <HiUpload className="h-4 w-4 text-[#F1A254]" />
                        <Text
                          className="text-[#595657] text-[14px]"
                          fontWeight={"700"}
                        >
                          Override
                        </Text>
                      </button>
                      <button>
                        <IoIosArrowDown className="h-4 w-4" />
                      </button>
                    </Stack>
                  </Td>
                </Tr>
              </Tbody>
            </Table>
          </Box>
        </Box>
        <Box minHeight={"192px"} margin={"40px 0px 10px 0px"}>
          <Text
            fontWeight={"700"}
            fontSize={"16px"}
            color={"#3A9391"}
            marginTop={"10px"}
          >
            Data Fetched from Third Party
          </Text>
          <Box style={{ marginTop: "10px" }}>
            <Table
              variant="unstyled"
              size="md"
              width="100%"
              bg="white"
              borderRadius="md"
            >
              <Thead>
                <Tr>
                  <Th
                    fontSize={"12px"}
                    color={"#595657"}
                    fontWeight={"400"}
                    fontFamily={"inter"}
                    textTransform={"capitalize"}
                  >
                    File
                  </Th>
                  <Th
                    fontSize={"12px"}
                    color={"#595657"}
                    fontWeight={"400"}
                    fontFamily={"inter"}
                    textTransform={"capitalize"}
                  >
                    Status
                  </Th>
                  <Th
                    fontSize={"12px"}
                    color={"#595657"}
                    fontWeight={"400"}
                    fontFamily={"inter"}
                    textTransform={"capitalize"}
                  >
                    Preview
                  </Th>
                  <Th
                    fontSize={"12px"}
                    color={"#595657"}
                    fontWeight={"400"}
                    fontFamily={"inter"}
                    textTransform={"capitalize"}
                  >
                    Human Action
                  </Th>
                  <Th
                    fontSize={"12px"}
                    color={"#595657"}
                    fontWeight={"400"}
                    fontFamily={"inter"}
                    textTransform={"capitalize"}
                  >
                    <span className="mx-auto">Source</span>
                  </Th>
                </Tr>
              </Thead>
              <Tbody style={{ border: "1px solid #E8E8E8" }}>
                <Tr style={{ borderBottom: "1px solid #E8E8E8" }}>
                  <Td>
                    <Stack direction="row" align="center" spacing={2}>
                      <FaRegFile className="h-4  w-4 text-[#F1A254]" />
                      <Text
                        fontWeight="400"
                        color={"#090705"}
                        fontSize={"14px"}
                      >
                        GST
                      </Text>
                      <IoMdInformationCircleOutline className="h-5 w-5 text-[#B3B3B3]" />
                      <button
                        style={{
                          border: "1px solid #E8E8E8",
                          color: "#F1A254",
                          height: "30px",
                          width: "46px",
                          backgroundColor: "#F8F8F8",
                          fontSize: "12px",
                          borderRadius: "8px",
                          fontWeight: "600",
                          marginLeft: "2px",
                        }}
                      >
                        Log
                      </button>
                    </Stack>
                  </Td>
                  <Td>
                    <Box
                      height={"25px"}
                      width={"90px"}
                      borderRadius={"14px"}
                      backgroundColor={"#FFEBEA"}
                      color={"#FF3B30"}
                      fontSize={"12px"}
                      fontWeight={"600"}
                      display={"flex"}
                      justifyContent={"center"}
                      alignItems={"center"}
                    >
                      Failed
                    </Box>
                  </Td>
                  <Td>
                    <IconButton
                      icon={<PiHandSwipeRightThin />}
                      variant="unstyled"
                      aria-label="Preview"
                    />
                  </Td>
                  <Td>
                    <IconButton
                      icon={<PiUserCheck />}
                      variant="unstyled"
                      aria-label="Human Approval"
                    />
                  </Td>
                  <Td className="text-[14px] text-[#090705]">GST</Td>
                </Tr>
                <Tr style={{ borderBottom: "1px solid #E8E8E8" }}>
                  <Td>
                    <Stack direction="row" align="center" spacing={2}>
                      <FaRegFile className="h-4  w-4 text-[#F1A254]" />
                      <Text
                        fontWeight="400"
                        color={"#090705"}
                        fontSize={"14px"}
                      >
                        Bureau Report
                      </Text>
                      <IoMdInformationCircleOutline className="h-5 w-5 text-[#B3B3B3]" />
                      <button
                        style={{
                          border: "1px solid #E8E8E8",
                          color: "#F1A254",
                          height: "30px",
                          width: "46px",
                          backgroundColor: "#F8F8F8",
                          fontSize: "12px",
                          borderRadius: "8px",
                          fontWeight: "600",
                          marginLeft: "2px",
                        }}
                      >
                        Log
                      </button>
                    </Stack>
                  </Td>
                  <Td>
                    <Box
                      height={"25px"}
                      width={"90px"}
                      borderRadius={"14px"}
                      backgroundColor={"#EFF6F6"}
                      color={"#3A9391"}
                      fontSize={"12px"}
                      fontWeight={"600"}
                      display={"flex"}
                      justifyContent={"center"}
                      alignItems={"center"}
                    >
                      Received
                    </Box>
                  </Td>
                  <Td>
                    <IconButton
                      icon={<PiHandSwipeRightThin />}
                      variant="unstyled"
                      aria-label="Preview"
                    />
                  </Td>
                  <Td>
                    <IconButton
                      icon={<PiUserCheck />}
                      variant="unstyled"
                      aria-label="Human Approval"
                    />
                  </Td>
                  <Td className="text-[14px] text-[#090705]">CIBIL</Td>
                </Tr>
                <Tr style={{ borderBottom: "1px solid #E8E8E8" }}>
                  <Td>
                    <Stack direction="row" align="center" spacing={2}>
                      <FaRegFile className="h-4  w-4 text-[#F1A254]" />
                      <Text
                        fontWeight="400"
                        color={"#090705"}
                        fontSize={"14px"}
                        className="whitespace-nowrap"
                      >
                        KYB Report
                      </Text>
                      <IoMdInformationCircleOutline className="h-5 w-5 text-[#B3B3B3]" />
                      <button
                        style={{
                          border: "1px solid #E8E8E8",
                          color: "#F1A254",
                          height: "30px",
                          width: "46px",
                          backgroundColor: "#F8F8F8",
                          fontSize: "12px",
                          borderRadius: "8px",
                          fontWeight: "600",
                          marginLeft: "2px",
                        }}
                      >
                        Log
                      </button>
                    </Stack>
                  </Td>
                  <Td>
                    <Box
                      height={"25px"}
                      width={"90px"}
                      borderRadius={"14px"}
                      backgroundColor={"#EFF6F6"}
                      color={"#3A9391"}
                      fontSize={"12px"}
                      fontWeight={"600"}
                      display={"flex"}
                      justifyContent={"center"}
                      alignItems={"center"}
                    >
                      Received
                    </Box>
                  </Td>
                  <Td>
                    <IconButton
                      icon={<PiHandSwipeRightThin />}
                      variant="unstyled"
                      aria-label="Preview"
                    />
                  </Td>
                  <Td>
                    <IconButton
                      icon={<PiUserCheck />}
                      variant="unstyled"
                      aria-label="Human Approval"
                    />
                  </Td>
                  <Td className="text-[14px] text-[#090705]">Hyperverge</Td>
                </Tr>
                <Tr style={{ borderBottom: "1px solid #E8E8E8" }}>
                  <Td>
                    <Stack direction="row" align="center" spacing={2}>
                      <FaRegFile className="h-4  w-4 text-[#F1A254]" />
                      <Text
                        fontWeight="400"
                        color={"#090705"}
                        fontSize={"14px"}
                        className="whitespace-nowrap"
                      >
                        Fraud Report
                      </Text>
                      <IoMdInformationCircleOutline className="h-5 w-5 text-[#B3B3B3]" />
                      <button
                        style={{
                          border: "1px solid #E8E8E8",
                          color: "#F1A254",
                          height: "30px",
                          width: "46px",
                          backgroundColor: "#F8F8F8",
                          fontSize: "12px",
                          borderRadius: "8px",
                          fontWeight: "600",
                          marginLeft: "2px",
                        }}
                      >
                        Log
                      </button>
                    </Stack>
                  </Td>
                  <Td>
                    <Box
                      height={"25px"}
                      width={"90px"}
                      borderRadius={"14px"}
                      backgroundColor={"#EFF6F6"}
                      color={"#3A9391"}
                      fontSize={"12px"}
                      fontWeight={"600"}
                      display={"flex"}
                      justifyContent={"center"}
                      alignItems={"center"}
                    >
                      Received
                    </Box>
                  </Td>
                  <Td>
                    <IconButton
                      icon={<PiHandSwipeRightThin />}
                      variant="unstyled"
                      aria-label="Preview"
                    />
                  </Td>
                  <Td>
                    <IconButton
                      icon={<PiUserCheck />}
                      variant="unstyled"
                      aria-label="Human Approval"
                    />
                  </Td>
                  <Td className="text-[14px] text-[#090705]">Probe 42</Td>
                </Tr>
              </Tbody>
            </Table>
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default LoanOfficerMain;
